import {createAction} from '@reduxjs/toolkit'
import {IUser} from '@wix/yoshi-flow-editor'

export const setCurrentUser = createAction<Partial<IUser>>('SET_CURRENT_USER')
